export default __webpack_public_path__ + "static/media/leftt.99ecf5c4.svg";